import { Flex, Modal, toast } from '@solinkcorp/solink-components';
import { withAspen } from 'components/aspen/withAspen';
import CenteredLoadingSpinner from 'loadingIndicator/CenteredLoadingSpinner';
import React from 'react';
import styled from 'styled-components';
import { ArchivePanelAspen } from './ArchivePanelAspen';
import {
  useArchivePanelActions,
  type ArchiveNotifier,
  type ArchivePanelProps,
} from './useArchivePanelActions';

const archiveNotifier: ArchiveNotifier = {
  success: (message, options) => {
    if (options === undefined) {
      toast.success(message);
      return;
    }
    toast.success(message, options);
  },
  error: (message) => {
    toast.error(message);
  },
};

export const ArchivePanel: React.FC<ArchivePanelProps> = (props) => {
  const {
    isLoading,
    modalCloseAction,
    onConfirm,
    modalTitle,
    archiveConfirmation,
    infoText,
    eventTitle,
    cancelLabel,
    confirmLabel,
  } = useArchivePanelActions(props, archiveNotifier);

  const actions = [
    {
      text: cancelLabel,
      onClick: modalCloseAction,
      isPrimary: false,
      disabled: isLoading,
    },
    {
      text: confirmLabel,
      onClick: onConfirm,
      disabled: isLoading,
    },
  ];

  return (
    <Modal
      isOpen={props.archivePanelOpen}
      onClose={modalCloseAction}
      title={modalTitle}
      actions={actions}
    >
      <ModalContent>
        {isLoading ? (
          <CenteredLoadingSpinner />
        ) : (
          <TextWrapper>
            <div>{archiveConfirmation}</div>
            <EventTitle>{eventTitle}</EventTitle>
            {infoText && <InfoText>{infoText}</InfoText>}
          </TextWrapper>
        )}
      </ModalContent>
    </Modal>
  );
};

const TextWrapper = styled.div`
  font-size: 16px;
`;

const InfoText = styled.div`
  color: var(--color-dark-gray-lighter);
  font-size: 14px;
  margin-top: 16px;
`;

const EventTitle = styled.div`
  font-weight: 400;
  padding: 4px 0;
`;

const ModalContent = styled(Flex)`
  width: 100%;
  flex-direction: row;
  height: 100%;
`;

export default withAspen(ArchivePanel, ArchivePanelAspen);
